const CATEGORY_KEY = {
  TOTAL: 'TOTAL',
  FASHION_CLOTHES: 'FASHION_CLOTHES',
  FASHION_ACCESSORIES: 'FASHION_ACCESSORIES',
  BEAUTY: 'BEAUTY',
  FOOD: 'FOOD',
  SPORT_LEISURE_CAR: 'SPORT_LEISURE_CAR',
  CHILD_BIRTH: 'CHILD_BIRTH',
  INTERIOR: 'INTERIOR',
  LIFE: 'LIFE',
  DIGITAL: 'DIGITAL',
  TRAVEL_TICKET_COUPON: 'TRAVEL_TICKET_COUPON',
  OVERSEA_DIRECT_PURCHASE: 'OVERSEA_DIRECT_PURCHASE',
} as const;

const CATEGORY_KEY_BY_NAME = {
  ['전체 랭킹']: 'TOTAL',
  ['패션의류']: 'FASHION_CLOTHES',
  ['패션잡화']: 'FASHION_ACCESSORIES',
  ['뷰티']: 'BEAUTY',
  ['식품']: 'FOOD',
  ['스포츠/레저/자동차']: 'SPORT_LEISURE_CAR',
  ['출산/육아']: 'CHILD_BIRTH',
  ['가구/인테리어']: 'INTERIOR',
  ['생활/건강']: 'LIFE',
  ['가전/디지털']: 'DIGITAL',
  ['여행/티켓/e쿠폰']: 'TRAVEL_TICKET_COUPON',
  ['해외직구']: 'OVERSEA_DIRECT_PURCHASE',
} as const;

type CategoryType = typeof CATEGORY_KEY[keyof typeof CATEGORY_KEY];
type CategoryName = keyof typeof CATEGORY_KEY_BY_NAME;

export type { CategoryType, CategoryName };
export { CATEGORY_KEY, CATEGORY_KEY_BY_NAME };
